import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Grid,
  GridItem,
  Image,
  Divider,
  Icon,
  Link,
  Flex,
} from "@chakra-ui/react";
import { BackwardIcon, DownIcon } from "../assets/Icons";
import MapImage from "../assets/Basemap image.png";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PieChartWithImage from "./PieChart";
import { getClientTrace } from "./api";
import GoogleMap from "./GoogleMap";
import CuLogo from "../assets/cu-logo-head.png";
import GCCLogo from "../../../assets/cotton.png";

function FarmersDetails() {
  const location = useLocation();
  const { traceVersion } = location.state || {};
  const navigate = useNavigate();
  const [details, setDetails] = useState([]);
  const { id } = useParams();
  const [farmerByState, setFarmerByState] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [farmers, setFarmers] = useState([]);
  const [apmcs, setApmcs] = useState([]);
  const [brokers, setBrokers] = useState([]);

  //api calls
  const getTraceDetails = async () => {
    try {
      const res = await getClientTrace(id, traceVersion);
      setDetails(res?.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  // const formatMarkers = (data) => {
  //   const dataByState = {};
  //   data.forEach((obj) => {
  //     const state = obj?.address?.state;
  //     const name = `${obj?.address?.city}, ${state}`;
  //     const position = {
  //       lat: obj?.address?.location?.coordinates?.[0],
  //       lng: obj?.address?.location?.coordinates?.[1],
  //     };
  //     if (position.lat != null && position.lng != null) {
  //       if (!dataByState[state]) {
  //         dataByState[state] = [];
  //       }
  //       dataByState[state].push({ name, position });
  //     }
  //   });

  //   const markersArray = [];
  //   for (const state in dataByState) {
  //     dataByState[state].forEach((marker) => markersArray.push(marker));
  //   }
  //   console.log(dataByState);
  //   setFarmerByState(dataByState);
  //   setMarkers(markersArray);
  // };

  const formatMarkers = (data) => {
    const dataByState = {};
    const markersArray = [];

    data.forEach((obj) => {
      const state = obj?.address?.state;
      const city = obj?.address?.city;
      const coordinates = obj?.address?.location?.coordinates;
      const name = `${city}, ${state}`;
      const position = {
        lat: coordinates?.[0],
        lng: coordinates?.[1],
      };
      if (!dataByState[state]) {
        dataByState[state] = [];
      }
      dataByState[state].push({
        name,
        position: coordinates ? position : undefined,
      });
      if (position.lat != null && position.lng != null) {
        markersArray.push({ name, position });
      }
    });
    setFarmerByState(dataByState);
    setMarkers(markersArray);
  };

  useEffect(() => {
    const combinedData = [...farmers, ...apmcs, ...brokers];
    if (combinedData.length > 0) {
      formatMarkers(combinedData);
    }
  }, [farmers, apmcs, brokers]);

  useEffect(() => {
    getTraceDetails();
  }, []);

  // useEffect(() => {
  //   const uniqueFarmers = [];

  //   details?.["Farmers"]?.forEach((el) => {
  //     const state = el?.address?.state;
  //     const farmerId = el?.id;

  //     if (!uniqueFarmers[state]) {
  //       uniqueFarmers[state] = [];
  //     }

  //     if (!uniqueFarmers[state].includes(farmerId)) {
  //       uniqueFarmers[state].push(el);
  //     }
  //   });
  //   setFarmerByState(uniqueFarmers);
  // }, [details]);

  // useEffect(() => {
  //   if (details) {
  //     setFarmers(details["Farmer"] || []);
  //     setApmcs(details["APMC"] || []);
  //     setBrokers(details["BROKER"] || []);
  //   }
  // }, [details]);

  useEffect(() => {
    if (details) {
      const getDataByKeys = (obj, keys) =>
        keys.reduce((acc, key) => acc || obj?.[key], null) || [];

      setFarmers(getDataByKeys(details, ["Farmers", "Farmer"]));
      setApmcs(getDataByKeys(details, ["APMC", "Apmcs", "Apmc"]));
      setBrokers(getDataByKeys(details, ["BROKER", "Brokers", "Broker"]));
    }
  }, [details]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const renderCategory = (categoryName, data) => (
    <Box bg="#F8F4F4" p="1rem" borderRadius="10px" mt="1rem" mb="2rem">
      <Text fontSize="13px" fontWeight="700" m={0}>
        {"Suppliers"}
      </Text>
      <Grid templateColumns="repeat(1, 1fr)" p="5px" gap="5px">
        {data.map((element) => (
          <GridItem key={element.id}>
            <Box p="5px" bg="rgba(156, 232, 179, 0.4);" borderRadius="10px">
              <Box p="5px">
                <Text fontSize="12px" fontWeight="600" m={0}>
                  {element?.name
                    ? element?.name
                    : `${element?.firstName || ""} ${element?.lastName || ""}`}
                </Text>
                <Text fontSize="10px" m={0} w="300px">
                  {[
                    element?.address?.raw_address,
                    element?.address?.city,
                    element?.address?.state,
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </Text>

                {element?.stockQuantity && (
                  <>
                    <Text fontSize="11px" m={0}>
                      Net Weight: {element.stockQuantity.netWeight} Kg
                    </Text>
                    <Text fontSize="11px" m={0}>
                      Gross Weight: {element.stockQuantity.grossWeight} Kg
                    </Text>
                  </>
                )}
              </Box>
            </Box>
          </GridItem>
        ))}
      </Grid>
    </Box>
  );

  return (
    <Box bg="white" maxW="480px">
      <Box
        bg="#EFEFF4"
        borderBottomRadius={"15px"}
        boxShadow={"rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
      >
        <Box bg="#EFEFF4" borderBottomRadius={"15px"} px={"2rem"}>
          <Grid templateColumns={"0.5fr 1.5fr"} pt={"2rem"}>
            <GridItem mt="5px">
              <BackwardIcon onClick={handleGoBack} />
            </GridItem>
            <GridItem>
              <Text fontSize="16px" fontWeight={"700"} mt="5px">
                Control Union India
              </Text>
            </GridItem>
          </Grid>
          <PieChartWithImage farmerByState={farmerByState} />
        </Box>
      </Box>
      <Box px="1.25rem">
        {markers?.length > 0 && (
          <>
            <Text fontSize="16px" fontWeight={"700"} mt="2rem">
              Farmers across Geography
            </Text>

            <Box
              position="relative"
              overflow="hidden"
              w="100%"
              pt="56.25%"
              marginTop={"1rem"}
            >
              <Box
                position="absolute"
                top={0}
                left={0}
                w="100%"
                h="100%"
                borderRadius="15px"
              >
                <GoogleMap markers={markers} />
              </Box>
            </Box>
          </>
        )}

        <Divider
          bg={"#AFAFAF"}
          width={"100%"}
          height={"1px"}
          my={"2rem"}
          borderRadius={"50px"}
        />

        <Box>
          {farmers?.length > 0 && renderCategory("Farmers", farmers)}
          {apmcs?.length > 0 && renderCategory("APMC", apmcs)}
          {brokers?.length > 0 && renderCategory("Brokers", brokers)}
        </Box>
      </Box>
    </Box>
  );
}

export default FarmersDetails;
